export function appendPendingPortfolio(current: File[], incoming: File[], maximum = 12): File[] {
  const merged = [...current];
  incoming.forEach((file) => {
    const key = `${file.name}:${file.size}:${file.lastModified}`;
    if (!merged.some((item) => `${item.name}:${item.size}:${item.lastModified}` === key)) merged.push(file);
  });
  return merged.slice(0, maximum);
}
